import { takeEvery, put, call } from "redux-saga/effects";

import {
  getCustomersAPI,
  addCustomerAPI,
  getCustomerAPI,
  updateCustomerAPI,
  deleteUserAPI,
} from "../../../helpers/backend.helper";
import {
  ADD_CUSTOMER,
  GET_CUSTOMERS,
  GET_CUSTOMER,
  UPDATE_CUSTOMER,
  DELETE_CUSTOMER,
} from "./actionTypes";
import {
  addCustomerError,
  addCustomerSuccess,
  getCustomersError,
  getCustomersSuccess,
  getCustomerError,
  getCustomerSuccess,
  updateCustomerSuccess,
  updateCustomerError,
  deleteCustomerSuccess,
  deleteCustomerError,
} from "./actions";

function* getCustomers({ payload: { request } }) {
  try {
    const response = yield call(getCustomersAPI, request);
    if (response) {
      yield put(getCustomersSuccess(response?.data));
    }
  } catch (error) {
    yield put(getCustomersError(error));
  }
}

function* addCustomer({ payload: { request } }) {
  try {
    const response = yield call(addCustomerAPI, request);
    if (response) {
      yield put(addCustomerSuccess());
    }
  } catch (error) {
    yield put(addCustomerError(error));
  }
}

function* getCustomer({ payload: { id } }) {
  try {
    const response = yield call(getCustomerAPI, id);
    if (response) {
      yield put(getCustomerSuccess(response?.data));
    }
  } catch (error) {
    yield put(getCustomerError(error));
  }
}

function* updateCustomer({ payload: { request } }) {
  try {
    const response = yield call(updateCustomerAPI, request);
    if (response) {
      yield put(updateCustomerSuccess());
    }
  } catch (error) {
    yield put(updateCustomerError(error));
  }
}

function* deleteCustomer({ payload: { id } }) {
  try {
    const response = yield call(deleteUserAPI, id);
    if (response) {
      yield put(deleteCustomerSuccess());
    }
  } catch (error) {
    yield put(deleteCustomerError(error));
  }
}

function* customersSaga() {
  yield takeEvery(GET_CUSTOMERS, getCustomers);
  yield takeEvery(ADD_CUSTOMER, addCustomer);
  yield takeEvery(GET_CUSTOMER, getCustomer);
  yield takeEvery(UPDATE_CUSTOMER, updateCustomer);
  yield takeEvery(DELETE_CUSTOMER, deleteCustomer);
}

export default customersSaga;
